module.exports = __webpack_public_path__ + "static/img/3-3.8822b86c.png";